import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=109ac73f&scoped=true&"
import script from "./AuditLogs.vue?vue&type=script&lang=js&"
export * from "./AuditLogs.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=109ac73f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109ac73f",
  null
  
)

export default component.exports